import { render, staticRenderFns } from "./AffiliateRecipes.vue?vue&type=template&id=7bb1a95d&"
import script from "./AffiliateRecipes.vue?vue&type=script&lang=js&"
export * from "./AffiliateRecipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports